import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {service} from '../redux/service'

interface Props {
  id: string
  handleClose: () => void
}

const Field = ({label, value}: {label: string; value?: string | number | null}) => (
  <div className='col-md-4 mb-3'>
    <div className='text-muted small'>{label}</div>
    <div className='fw-semibold'>{value ?? '-'}</div>
  </div>
)

const SectionHeading = ({title}: {title: string}) => (
  <div className='col-12 mt-3 mb-2'>
    <h6 className='text-primary border-bottom pb-1 mb-0'>{title}</h6>
  </div>
)

const ViewCreditEligibilityDetails = ({id, handleClose}: Props) => {
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    service
      .getCreditEligibilityReportDetail(id)
      .then((res) => setRecord(res.data?.data))
      .catch(() => toast.error('Failed to load credit eligibility submission details.'))
      .finally(() => setLoading(false))
  }, [id])

  return (
    <div className='modal show d-block' style={{background: 'rgba(0,0,0,0.5)'}}>
      <div className='modal-dialog modal-xl modal-dialog-scrollable'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Credit Eligibility Submission — {record?.eligibility_code || id}
            </h5>
            <button className='btn-close' onClick={handleClose} />
          </div>
          <div className='modal-body'>
            {loading ? (
              <div className='text-center py-5'>
                <div className='spinner-border text-primary' />
              </div>
            ) : !record ? (
              <div className='alert alert-danger'>Submission not found.</div>
            ) : (
              <div className='row'>
                <Field
                  label='Full Name'
                  value={[record.first_name, record.middle_name, record.last_name]
                    .filter(Boolean)
                    .join(' ')}
                />
                <Field label='Date of Birth (AD)' value={record.date_of_birth_ad} />
                <Field label='Date of Birth (BS)' value={record.date_of_birth_bs} />
                <Field label='Email Address' value={record.email_address} />
                <Field label='Mobile Number' value={record.mobile_number} />
                <Field label='Nationality' value={record.nationality} />
                <Field label='Employment Type' value={record.employment_type} />
                <Field label='Preferred Branch' value={record.preferred_branch} />
                <Field label='Card Type' value={record.card_type} />

                <SectionHeading title='Legacy Scoring Inputs (old CMS, no crosswalk to new rubric)' />
                <Field label='Home Class' value={record.legacy_home_class_label} />
                <Field label='Dependents' value={record.legacy_dependents_label} />
                <Field label='Occupation Type' value={record.legacy_occupation_type_label} />
                <Field label='Occupational Income' value={record.occupational_income} />
                <Field label='Occupation Length' value={record.legacy_occupation_length_label} />
                <Field label='Reference' value={record.legacy_reference_label} />
                <Field label='Account With Bank' value={record.account_with_bank} />
                <Field label='Account Number' value={record.account_number} />
                <Field label='Relationship With Nabil' value={record.legacy_relationship_label} />
                <Field label='Reliability of Evidence' value={record.legacy_reliability_label} />

                <SectionHeading title='Outcome' />
                <Field label='Total Score' value={record.totalscore} />
                <Field label='Eligibility Amount' value={record.eligibility_amount} />
                <Field label='Eligibility Code' value={record.eligibility_code} />
                <Field label='Eligibility Status' value={record.eligibility_status} />
                <Field label='Request Status' value={record.request_status} />
                <Field label='Submitted At' value={record.submission_date_time} />
              </div>
            )}
          </div>
          <div className='modal-footer'>
            <button className='btn btn-secondary btn-sm' onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewCreditEligibilityDetails
